export default __webpack_public_path__ + "static/media/blog-32-image-1.d1e21d27.jpg";